<template>
  <div class="resume">
    <div class="container">
      <div style="height: 0.2rem"></div>
      <div class="have b-r" v-if="show">
        <div class="more">
          <img src="../assets/img/more.png" alt="" />
        </div>
        <p>暂无电子简历</p>
        <div>
          <el-button @click="UpFound" type="primary">上传电子简历</el-button>
          <el-button type="success" @click="toFound">创建电子简历</el-button>
        </div>
      </div>
      <div class="not" v-else>
        <!-- 个人信息 -->
        <Chart path="/user/personal">
          <h4 slot="title">个人信息：</h4>
          <div slot="tab">
            <table
              border="1"
              width="100%"
              style="border-collapse: collapse; border: 1px solid #d8d8d8"
            >
              <tr>
                <td>{{ resume.user.name }}</td>
                <td>{{ resume.user.sex_name }}</td>
                <td colspan="2">{{ resume.user.age }}</td>
              </tr>
              <tr>
                <td>{{ resume.user.degree }}</td>
                <td>{{ resume.user.identity }}</td>
                <td>{{ resume.user.marriage_state }}</td>
                <td>{{ resume.user.work_state }}</td>
              </tr>
              <tr>
                <td colspan="4">现住地址：{{ resume.user.address }}</td>
              </tr>
              <tr>
                <td colspan="2">手机：{{ resume.user.mobile }}</td>
                <td colspan="2">{{ $store.state.user.userInfo.user.email }}</td>
              </tr>
              <tr>
                <td colspan="4">身份证号：{{ resume.user.idcard }}</td>
              </tr>
            </table>
          </div>
        </Chart>
        <!-- 工作经历 -->
        <Chart path="/user/undergo">
          <h4 slot="title">工作经历：</h4>
          <div slot="tab">
            <div v-if="undergoList.length > 0">
              <table
                border="1"
                width="100%"
                style="border-collapse: collapse; border: 1px solid #d8d8d8"
                v-for="(item, index) in undergoList"
                :key="index"
              >
                <tr>
                  <td colspan="4">
                    <h4>
                      {{ item.company }}
                    </h4>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">{{ item.monthly_salary }} 元/月</td>
                  <td colspan="2">
                    <!-- 时间 -->
                    {{
                      $dateFormat(item.start_time) +
                      "-" +
                      $dateFormat(item.end_time)
                    }}
                  </td>
                </tr>
                <tr>
                  <td colspan="4"><h4>工作描述：</h4></td>
                </tr>
                <tr>
                  <td colspan="4">
                    <p>{{ item.description }}</p>
                  </td>
                </tr>
                <tr>
                  <td colspan="4"><h4>主要业绩：</h4></td>
                </tr>
                <tr>
                  <td colspan="4">
                    <p>{{ item.results }}</p>
                  </td>
                </tr>
              </table>
            </div>

            <div v-else>
              <el-empty :image-size="100">
                <el-button @click="ToPerfect('/user/undergo')" type="primary"
                  >去完善</el-button
                >
              </el-empty>
            </div>
          </div>
        </Chart>
        <!-- 项目经历 -->
        <Chart path="/user/project">
          <h4 slot="title">项目经历：</h4>
          <div slot="tab">
            <div v-if="projectList.length > 0">
              <table
                border="1"
                width="100%"
                style="border-collapse: collapse; border: 1px solid #d8d8d8"
                v-for="(item, index) in projectList"
                :key="index"
              >
                <tr>
                  <td colspan="4">
                    <h4>{{ item.title }}</h4>
                  </td>
                </tr>
                <tr>
                  <td colspan="4">
                    {{
                      $dateFormat(item.start_time) +
                      "-" +
                      $dateFormat(item.end_time)
                    }}
                  </td>
                </tr>
                <tr>
                  <td colspan="4"><h4>项目描述：</h4></td>
                </tr>
                <tr>
                  <td colspan="4">
                    <p>{{ item.descript }}</p>
                  </td>
                </tr>
              </table>
            </div>
            <div v-else>
              <el-empty :image-size="100">
                <el-button @click="ToPerfect('/user/project')" type="primary"
                  >去完善</el-button
                >
              </el-empty>
            </div>
          </div>
        </Chart>
        <!-- 教育经验 -->
        <Chart path="/user/education">
          <h4 slot="title">教育经历：</h4>
          <div slot="tab">
            <div v-if="educates.length > 0">
              <table
                border="1"
                width="100%"
                style="border-collapse: collapse; border: 1px solid #d8d8d8"
                v-for="(item, index) in educates"
                :key="index"
              >
                <tr>
                  <td colspan="2">
                    <h4>{{ item.school }}</h4>
                  </td>
                  <td>
                    <h4>{{ item.professional }}</h4>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    {{
                      $dateFormat(item.start_time) +
                      "-" +
                      $dateFormat(item.end_time)
                    }}
                  </td>
                  <td>{{ item.degree_name }}</td>
                </tr>
              </table>
            </div>
            <div v-else>
              <el-empty :image-size="100">
                <el-button @click="ToPerfect('/user/education')" type="primary"
                  >去完善</el-button
                >
              </el-empty>
            </div>
          </div>
        </Chart>
        <!-- 自我介绍 -->
        <Chart path="/user/Self">
          <h4 slot="title">自我介绍：</h4>
          <div slot="tab">
            <div v-if="resume.user.self_evaluate != null" class="user_info">
              <div class="user_pic">
                <img :src="resume.user.head_pic" alt="" />
              </div>
              <table
                border="1"
                width="100%"
                style="border-collapse: collapse; border: 1px solid #d8d8d8"
              >
                <tr>
                  <td colspan="4">
                    <div v-html="resume.user.self_evaluate"></div>
                  </td>
                </tr>
              </table>
            </div>
            <div v-else>
              <el-empty :image-size="100">
                <el-button @click="ToPerfect('/user/Self')" type="primary"
                  >去完善</el-button
                >
              </el-empty>
            </div>
          </div>
        </Chart>
        <!-- 资质荣誉 -->
        <Chart path="/user/certificate">
          <h4 slot="title">资质荣誉：</h4>
          <div slot="tab">
            <div class="honor" v-if="certList.length > 0">
              <div class="con" v-for="(item, index) in certList" :key="index">
                <div class="honor_img">
                  <img :src="item.cert_imgs" alt="" />
                </div>
                <div class="honor_text">
                  <h5>{{ item.name }}</h5>
                  <p>{{ $format(item.obtain_time) }}获得</p>
                </div>
              </div>
            </div>
            <div v-else>
              <el-empty :image-size="100">
                <el-button
                  @click="ToPerfect('/user/certificate')"
                  type="primary"
                  >去完善</el-button
                >
              </el-empty>
            </div>
          </div>
        </Chart>
        <Chart path="/user/language">
          <h4 slot="title">语言能力：</h4>
          <div slot="tab">
            <div class="language" v-if="languages.length > 0">
              <div class="con" v-for="(item, index) in languages" :key="index">
                <h5>{{ item.lang }}</h5>
                <div>
                  听说<el-progress
                    :percentage="item.listen"
                    :format="format"
                    :stroke-width="3"
                  ></el-progress>
                </div>
                <div>
                  读写<el-progress
                    :percentage="item.read"
                    :format="format"
                    :stroke-width="3"
                  ></el-progress>
                </div>
              </div>
            </div>
            <div v-else>
              <el-empty :image-size="100">
                <el-button @click="ToPerfect('/user/language')" type="primary"
                  >去完善</el-button
                >
              </el-empty>
            </div>
          </div>
        </Chart>
        <div class="sub">
          <el-button @click="ToAlready" type="success">查看岗位</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from "@/components/Chart.vue";
export default {
  props: {},
  data() {
    return {
      show: false,
      resume: {},
      undergoList: "",
      projectList: "",
      educates: "",
      languages: "",
      certList: "",
    };
  },
  computed: {},
  created() {
    this.judgeShow();
  },
  mounted() {},
  watch: {},
  methods: {
    // 完善
    ToPerfect(path) {
      let rout = path;
      console.log(rout);
      this.$router.push(rout);
    },

    // 去创建简历界面
    toFound() {
      this.$router.push("/user/personal");
    },
    // 去个人信息页上传简历
    UpFound() {
      this.$router.push("/user/info");
    },

    format(percentage) {
      // return percentage === 66.66 ? "熟练" : `${percentage}%`;
      if (percentage <= 10) {
        return "一般";
      } else if (percentage <= 40) {
        return "良好";
      } else if (percentage <= 70) {
        return "熟练";
      } else {
        return "精通";
      }
    },
    ToAlready() {
      this.$router.push("/user/already");
    },
    // 判断用户是否有无电子简历
    judgeShow() {
      let isResume = this.$store.getters.isResume;
      if (isResume) {
        this.show = false;
        if (this.$store.state.user.userInfo.resume) {
          this.resume = this.$store.state.user.userInfo.resume;
          this.undergoList = this.$store.state.user.userInfo.resume.works;
          this.projectList = this.$store.state.user.userInfo.resume.projects;
          this.educates = this.$store.state.user.userInfo.resume.educates;
          this.languages = this.$store.state.user.userInfo.resume.languages;
          this.certList = this.$store.getters.resume.certs;
        }
      } else {
        this.show = true;
      }
    },
  },
  components: {
    Chart,
  },
};
</script>

<style lang="less" scoped>
.resume {
  padding-bottom: 0.5rem;
  .have {
    width: 100%;
    height: 3.4rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .more {
      width: 1.43rem;
      height: 1.43rem;
      background-color: rgb(238, 173, 52);
      border-radius: 50%;
      padding: 0.2rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
    p {
      font-size: 0.18rem;
      color: #333;
      line-height: 0.4rem;
      margin-bottom: 0.3rem;
    }
  }

  .not {
    .tab .honor {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .con {
        width: 45%;
        border-bottom: 1px solid #0000004a;
        display: flex;
        .honor_img {
          width: 1.3rem;
          height: 0.8rem;
          margin: 0.1rem;
          border: 1px solid rgba(51, 51, 51, 0.651);
          border-radius: 0.1rem;
          img {
            width: 100%;
            height: 100%;
            border-radius: 0.1rem;
          }
        }
        .honor_text {
          display: flex;
          flex-direction: column;
          justify-content: center;
          h5 {
            font-size: 0.14rem;
          }
          p {
            font-size: 0.14rem;
          }
        }
      }
    }
    .language {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .con {
        width: 45%;
        margin-top: 0.3rem;
        h5 {
          font-size: 0.14rem;
        }
        div {
          font-size: 0.14rem;
        }
      }
    }
    .sub {
      display: flex;
      justify-content: center;
      margin-top: 0.3rem;
    }
    .user_info {
      display: flex;
      align-items: flex-start;
      .user_pic {
        width: 1rem;
        height: 1rem;
        padding: 0.1rem;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
@media only screen and (max-width: 766px) {
  .resume {
    .have {
      height: 6rem;
    }
    .not {
      .tab {
        tr {
          td {
            font-size: 0.24rem;
            h4 {
              font-size: 0.26rem;
            }
            h5 {
              font-size: 0.24rem;
            }
          }
        }
        .honor {
          .con {
            width: 100%;
            .honor_img {
              width: 2.6rem;
              height: 1.6rem;
            }
            .honor_text {
              h5 {
                font-size: 0.24rem;
              }
              p {
                font-size: 0.24rem;
              }
            }
          }
        }
      }
      .language {
        .con {
          width: 100%;
          h5 {
            font-size: 0.26rem;
          }
          div {
            font-size: 0.24rem;
          }
        }
      }
    }
  }
}
</style>
